<template>
  <div class="guest-layout">
    <img class="guest-layout__logo" src="../assets/logo.png"/>
    <slot>
      <router-view class="full-width" />
    </slot>
    <p class="text-center q-my-lg">
      <privacy-policy-link />
    </p>
  </div>
</template>

<style lang="scss">
    .guest-layout {
        max-width: 480px;
        margin: 1rem auto;
        padding: 0 1rem;

        &__logo {
            display: block;
            max-width: 65%;
            margin: 1rem auto;
        }
    }
</style>
<script>
import PrivacyPolicyLink from '@/PrivacyPolicyLink.vue';

export default {
  components: { PrivacyPolicyLink },
};
</script>
